import { FC } from 'react';
import useLocales from '@hooks/useLocales';
import { Box, Button, Grid, Typography, useTheme } from '@mui/material';
import { useStyles } from './styles';
import { useSignUpRedirect } from '~/hooks/useSignUpRedirect';
import SvgIconStyle from '~/components/SvgIconStyle';

const LoFinancialPerfomanceBlock: FC = () => {
  const { t } = useLocales();
  const theme = useTheme();
  const styles = useStyles(theme);
  const { signUpRedirect } = useSignUpRedirect();
  return (
    <Grid container sx={styles.container}>
      {/* <Grid item sx={styles.imagBox}>
        <Image alt="cover" src="/lo-financial-perfomance.png" sx={styles.image} />
      </Grid> */}
      <Grid item sx={styles.textGrid}>
        <Box sx={styles.textBox}>
          {/* <Typography variant="overline" sx={styles.greyText}>
            {t('landing.feature')}
          </Typography> */}
          <SvgIconStyle src="/icons/landing/ic_performance.svg" sx={styles.icon} />
          <Typography variant="h3" sx={styles.title}>
            {t('landing.perf_title')}
          </Typography>
          <Typography variant="body1" sx={styles.text}>
            {t('landing.perf_body')}
          </Typography>
          <Button
            variant="outlined"
            size="large"
            color="inherit"
            sx={styles.button}
            onClick={signUpRedirect}
          >
            {t('landing.get_started')}
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default LoFinancialPerfomanceBlock;
